import { render, staticRenderFns } from "./Dispensary.vue?vue&type=template&id=f6c69514&scoped=true&"
import script from "./Dispensary.vue?vue&type=script&lang=js&"
export * from "./Dispensary.vue?vue&type=script&lang=js&"
import style0 from "./Dispensary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c69514",
  null
  
)

export default component.exports